import { ASSET_TYPES } from '../../../../services/investmentPlanningService';

export const TYPE_ASSET_PREFIX = 'typeAsset::';
export const TYPE_DEBT_PREFIX = 'typeDebt::';
export const UNLINKED_DEBT_KEY = 'typeDebt::unlinked';

export function getAssetTypeLabel(type) {
  if (type === 'unlinked') return 'Passifs non liés';
  return ASSET_TYPES.find((t) => t.value === type)?.label || type;
}

export function getTypesFromBundle(bundle) {
  return bundle?.assetTypes || [];
}

export function getTypeAssetValue(row, type) {
  return row?.[`${TYPE_ASSET_PREFIX}${type}`] ?? 0;
}

export function getTypeDebtValue(row, type) {
  return row?.[`${TYPE_DEBT_PREFIX}${type}`] ?? 0;
}

export function getUnlinkedDebtValue(row) {
  return row?.[UNLINKED_DEBT_KEY] ?? 0;
}

/** Séries temporelles pour un type : actifs, passifs liés, valeur nette. */
export function buildTypeTimeSeries(projection, type) {
  return (projection || []).map((row) => {
    const point = {
      year: row.year,
      assets: getTypeAssetValue(row, type),
      debts: getTypeDebtValue(row, type),
      net: getTypeAssetValue(row, type) - getTypeDebtValue(row, type),
    };
    if (type === 'assurance_participative') {
      point.deathBenefit = row?.assuranceDeathBenefitTotal ?? 0;
      point.encumbranceAvailable = row?.collateralCapacityTotal ?? 0;
    }
    return point;
  });
}

/** Instantané annuel pour tous les types (+ passifs non liés). */
export function buildTypeSnapshotAtYear(row, types, includeUnlinked = false) {
  const items = types.map((type) => {
    const assets = getTypeAssetValue(row, type);
    const debts = getTypeDebtValue(row, type);
    const item = {
      type,
      label: getAssetTypeLabel(type),
      assets,
      debts,
      net: assets - debts,
    };
    if (type === 'assurance_participative') {
      item.deathBenefit = row?.assuranceDeathBenefitTotal ?? 0;
    }
    return item;
  });

  if (includeUnlinked) {
    const unlinked = getUnlinkedDebtValue(row);
    if (unlinked > 0) {
      items.push({
        type: 'unlinked',
        label: getAssetTypeLabel('unlinked'),
        assets: 0,
        debts: unlinked,
        net: -unlinked,
      });
    }
  }

  return items.filter((i) => i.assets > 0 || i.debts > 0 || (i.deathBenefit || 0) > 0);
}

export function pickDefaultAssetType(types) {
  if (!types?.length) return null;
  if (types.includes('assurance_participative')) return 'assurance_participative';
  return types.find((t) => t === 'immobilier') || types[0];
}
